import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, autofill } from 'redux-form';
import moment from 'moment';
import compose from 'lodash/fp/compose';
import _ from 'lodash';

import { CURRENT_CLIENT_FORM } from 'src/constants/FormNames';
import { Section } from 'jbc-front/components/Form';
import { setItem, getItem, getItemErrors } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, updateToPaidPlan, isTrialPlan } from 'src/reducers/clients/currentClient';
import UpdateToPaidPlanForm from './components/UpdateToPaidPlanForm';
import styles from './EditClientPaidPlan.scss';

const selector = formValueSelector(CURRENT_CLIENT_FORM);

const mapStateToProps = state => ({
  initialValues: {
    billInfo: {
      ..._.pick(getItem(REDUCER_NAME, state), [
        'postalCodePart0',
        'postalCodePart1',
        'prefectureId',
        'city',
        'street',
        'building',
        'telPart0',
        'telPart1',
        'telPart2',
        'name'
      ]),
      employeeEmail: state.currentUser.email,
      employeeFirstName: state.currentUser.firstName,
      employeeLastName: state.currentUser.lastName
    },
    creditInfo: {
      employeeEmail: state.currentUser.email
    },
    paymentMethodType: 'bill'
  },
  paymentMethodType: selector(state, 'paymentMethodType'),
  confirming: selector(state, 'confirmingState'),
  cardInfo: selector(state, 'creditInfo._cardInfo'),
  cardToken: selector(state, 'creditInfo.cardToken'),
  errors: getItemErrors(REDUCER_NAME, state),
  currentUser: state.currentUser
});

const mapDispatchToProps = dispatch => {
  const changeConfirming = confirming => dispatch(autofill(CURRENT_CLIENT_FORM, 'confirmingState', confirming));
  return {
    changeEditable: editable => changeConfirming(!editable),
    onSubmit: data => {
      if (data.confirmingState) {
        dispatch(updateToPaidPlan(data));
        return;
      }
      window.scrollTo(0, 0);
      changeConfirming(true);
    }
  };
};

const validate = values => {
  const errors = {};
  // 利用規約のチェック
  if (values.agreeToTOS !== true) {
    errors.agreeToTOS = 'に同意してください';
  }
  return errors;
};

const EditClientPaidPlanForm = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: CURRENT_CLIENT_FORM,
    validate
  })
)(UpdateToPaidPlanForm);

const EditClientPaidPlan = ({ dispatch, client }) => {
  dispatch(setItem(REDUCER_NAME, client));
  const now = moment();
  const endDay =
    !isTrialPlan(client.planType) || now.isAfter(client.trialFinishAt) ? now : moment(client.trialFinishAt);
  const billingStartOn = endDay
    .clone()
    .add(1, 'month')
    .startOf('month');
  const firstBillSend = billingStartOn.clone().add(1, 'month');

  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">有料プランお申し込みフォーム</h1>
      </div>
      <div className="l-contents-wrap">
        <div className="l-wrap-xs">
          <Section title="有料プラン申し込み後のご請求について">
            <dl className={styles.field}>
              <dt>ご利用料金：</dt>
              <dd>400円／従業員</dd>
            </dl>
            <dl className={styles.field}>
              <dt>契約月：</dt>
              <dd>{now.format('YYYY年MM月')}</dd>
            </dl>
            <dl className={styles.field}>
              <dt>初回料金発生月：</dt>
              <dd>{billingStartOn.format('YYYY年MM月')}</dd>
            </dl>
          </Section>
          <EditClientPaidPlanForm firstBillSend={firstBillSend} />
          <Section>
            <ul className={styles.notes}>
              <li>※ ご解約は解約希望月末日までにご連絡をお願いいたします。</li>
              <li>※ 料金発生月前にご解約いただいた場合、料金は発生いたしません。</li>
              <li>
                ※ 請求書払い（銀行・コンビニ）には、株式会社ネットプロテクションズの「NP掛け払い」を利用しています。
              </li>
            </ul>
            <dl className={styles.glossary}>
              <dt>「NP掛け払い」とは：</dt>
              <dd>法人/個人事業主を対象とした掛け払いサービスです。（月末締め翌月末請求書払い）</dd>
              <dd>請求書は、ご利用された月の翌月第2営業日に株式会社ネットプロテクションズから発行されます。</dd>
              <dd>請求書に記載されている銀行口座または、コンビニの払込票でお支払いください。</dd>
              <dd>銀行振込の際の振込手数料はお客様にてご負担ください。</dd>
              <dd>請求代行のため代金債権は同社へ譲渡されます。</dd>
            </dl>
          </Section>
        </div>
      </div>
    </div>
  );
};

export default connect()(EditClientPaidPlan);
